export default "//yastatic.net/s3/distribution/pythia/frontend/_/69bc4227fe4f03ef01f4c74e60d98a1a.svg";